import { NavLink, Text, ThemeIcon } from "@mantine/core";
import LogoutRounded from "@mui/icons-material/LogoutRounded";
import { runLogoutFunctions } from "@utils/accessChecks";
import { getDaysToExpiry, getMembershipIcon } from "@utils/meta";
import { Session } from "next-auth/core/types";
import Link from "next/link";
import { Dispatch, SetStateAction } from "react";
import {
  useCustomDispatch,
  useUserReduxProgressMetadataSelector,
} from "../../../../../lib/redux/hooks";
import classes from "./UserModal.module.css";
export default function UserModal({
  userMeta,
  opened,
  setOpened,
}: {
  userMeta: Session["user"];
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useCustomDispatch();
  const { name, role, subscriptionMeta } = userMeta;
  const membershipMeta = getMembershipIcon(role, subscriptionMeta);
  const membershipColor = membershipMeta.color;
  const userReduxProgressMetadata = useUserReduxProgressMetadataSelector();
  const iconProps = { style: { width: "1.6rem", height: "1.6rem" } };
  const membershipName = membershipMeta.name;
  const MembershipIcon = membershipMeta.Icon;
  const durationLabel =
    userMeta.role !== "Private"
      ? "Unlimited access"
      : subscriptionMeta?.status === "expired"
      ? "Access expired"
      : subscriptionMeta?.status === "suspended"
      ? "Payment failed"
      : subscriptionMeta?.billingAnchor
      ? `${getDaysToExpiry(subscriptionMeta.billingAnchor)} left`
      : "";

  return (
    <div className={classes.layout}>
      <NavLink
        className={`${classes.profileLink} side-nav-profile-link`}
        component={Link}
        href={"/profile"}
        aria-label={`${name} (${membershipName})`}
        label={
          <div className={classes.profileLabel}>
            <Text className={classes.profileTitle} lineClamp={1}>
              {membershipName}
            </Text>
            {durationLabel ? (
              <Text className={classes.profileSubtitle} lineClamp={1}>
                {durationLabel}
              </Text>
            ) : null}
          </div>
        }
        leftSection={
          <ThemeIcon
            className={classes.membershipIcon}
            color={membershipColor}
            variant="filled"
          >
            <MembershipIcon style={{ width: 20, height: 20 }} />
          </ThemeIcon>
        }
        onClick={() => {
          opened && setOpened(false);
        }}
      />
      <NavLink
        className={classes.logoutLink}
        component="button"
        type="button"
        label="Logout"
        leftSection={
          <ThemeIcon color="incorrect" variant="filled">
            <LogoutRounded {...iconProps} />
          </ThemeIcon>
        }
        onClick={async () => {
          await runLogoutFunctions(
            dispatch,
            userMeta.documentId,
            userReduxProgressMetadata,
          );
        }}
      />
    </div>
  );
}
